<template>
<div>
    <!-- <button
            class="bg-red-500 hover:bg-red-700 text-white font-bold py-2 px-4 rounded"
            @click="setAllAddonsToZero"
        >
            Set All Addons to 0
        </button> -->
	<div class="bg-white shadow-o rounded-md sm:rounded-lg p-6 py-8 lg:px-8 md:mt-8">
		<h3 class="text-lg leading-6 text-gray-700 font-poppins font-bold pb-4 sm:pb-6" v-if="!stylingNewVersion">
			Customise Your Membership
		</h3>
        <div
            class="items-center justify-between flex" 
                :class="{
                        'mb-2 sm:mb-3' : stylingNewVersion,
                        'border-b border-gray-200 pb-1 mb-3 sm:mb-4' : !stylingNewVersion
                    }"
        >
            <h3 class="leading-6 font-bold font-poppins text-gray-700" 
                    :class="{
                        'text-lg' : stylingNewVersion,
                        'text-md sm:text-lg' : !stylingNewVersion
                    }">
                Your {{ stylingNewVersion ? 'Quote' : 'Cover' }}
            </h3>
                <button
                    class="items-center text-sm sm:text-md leading-6 font-medium text-gray-900"
                    :class="{
                        'flex' : stylingNewVersion,
                        'hidden lg:flex' : !stylingNewVersion
                    }"
                    @click.prevent="toggleShowDescript"
                >
                <img src="/img/icons/svg/info-icon.svg" class="opacity-80" />
                    <span class="pl-1 text-gray-700">
                        {{
                            this.showDescription
                                ? "Hide"
                                : "Show"
                        }}
                        <span class="hidden md:inline"> Descriptions</span>
                    </span>
                </button>
            </div>

            <p v-if="stylingNewVersion" class="mb-1 md:mb-3 text-sm text-gray-500" :class="{
                'pt-1 md:pt-0' : showMultiVehicleWording && !isBusinessFlow() && this.form.vehicles.length > 1
            }">
                <span v-if="this.form?.cover_type?.value === 'personalCover'">
                    <span class="hidden lg:inline-block">Please review and customise your cover below.</span>
                    <span class="lg:hidden">Please review and customise your cover.</span>
                </span>
                <span v-else-if="isBusinessFlow()">
                    <span v-if="this.form.vehicles.length > 1">
                        Review and customise your business breakdown cover for {{ this.form.vehicles.length }} vehicles below.
                    </span>
                    <span v-else>
                        Review and customise your business breakdown cover below.
                    </span>
                </span>
                <span v-else>
                    <span class="hidden lg:inline-block">Review and customise your cover below.</span>
                    <span class="lg:hidden">Review and customise your cover.</span>
                </span>

                <span v-if="!isBusinessFlow() && this.form.vehicles.length > 1">
                    <span v-if="this.form.vehicles.length === 2">Your price includes cover for {{ this.form.vehicles.length }} vehicles.</span>
                    <span v-if="this.form.vehicles.length > 2">Your price includes cover for {{ this.form.vehicles.length }} vehicles.</span>
                </span>

                <span v-if="this.form?.cover_type?.value === 'personalCover' && this.form?.people?.length === 1">
                    This price provides <b>Joint Cover</b> for two members.
                </span>
                <span v-else-if="this.form?.cover_type?.value === 'personalCover' && this.form?.people?.length > 1">
                    This price provides <b>Family Cover</b> for a maximum of four members.
                </span>
            </p>

            <!-- Included As Standard -->
            <div class=""
                    :class="{
                        'mt-2.5 sm:mt-3 px-0.5 sm:px-0' : stylingNewVersion,
                        'mt-4 px-2 sm:px-0' : !stylingNewVersion
                    }">
                <service-information
                    v-for="service in includedAsStandard"
                    :key="service"
                    :title="form[service].label"
                    :description="
                        form[service].label == 'Home Start'
                            ? form[service].descriptionCover
                            : form[service].description
                    "
                    :removable="form[service].removable"
                    @remove-service="reviewRemoveService"
                    :show-description="showDescription"
                    :hex-color="hexColor"
                    :styling-new-version="stylingNewVersion"
                    :service-slug="service"
                ></service-information>
            </div>

            <h3 class="leading-6 font-bold text-gray-700 flex items-center"
                :class="{
                        '-mb-2 text-base sm:text-lg pt-6 sm:pt-7' : stylingNewVersion,
                        'border-b border-gray-200 pb-1 mb-6 text-base sm:text-lg pt-6' : !stylingNewVersion
                }">
                <!-- Addons -->
                <!-- Here are some options for your piece of mind -->
                <span class="font-poppins">Options for Extra Peace of Mind</span>

                <span v-if="false && quote.coupon !== 'undefined' && quote.coupon && quote.coupon.discountType === 'PERCENTAGE'"
                        class="text-white bg-red-500 px-2 md:px-2 font-bold text-sm rounded-md inline-block mb-1 uppercase py-1 sm:py-1 ml-4 lg:ml-3 whitespace-nowrap"
                    >
                        {{quote.coupon.discount}}% OFF 
                </span>
            </h3>

            <div v-for="(addon, index) in addons" :key="addon" class="mt-6" 
                    :class="{
                        'px-0.5 sm:px-0' : stylingNewVersion,
                        'px-2 sm:px-0' : !stylingNewVersion
                    }">
                <button-group
                    @change="updateQuotePrice"
                    :name="addon"
                    :ref="addon"
                    v-model="form[addon].value"
                    :options="form[addon].optionsToggle"
                    :label="form[addon].label"
                    :description="form[addon].description"
                    :hide-selected="form[addon].hideWhenSelected"
                    :service-price-object="servicePricing.filter(item => item.slug === addon)"
                    :errors-array="errorsArray"
                    :hide-bottom-border="index === addons.length - 1"
                    :flow-icon-version="flowIconVersion"
                ></button-group>
            </div>

            <!-- HIDE PARTS AND GARAGE: 27.08.2024
        <div v-if="!isWhiteLabel">
            <h3 v-if="extras.length > 0" class="text-md sm:text-lg leading-6 font-medium text-gray-900 mb-6 border-b border-gray-200 pt-8 pb-1">
                Get help with repair bills after MA attends my breakdown...
            </h3>

            <div v-for="extra in extras" :key="extra" class="mt-6 px-2 sm:px-0">

                <button-group
                    @change="updateQuotePrice"
                    :name="extra"
                    v-model="form[extra].value"
                    :options="form[extra].optionsToggle"
                    :label="form[extra].label"
                    :description="form[extra].description"
                    :hide-selected="form[extra].hideWhenSelected"
                    :info-blurb="form[extra].extrasInfo"
                ></button-group>

            </div>
        </div>
        -->

        <div v-if="form.parts_labour.value == 1" class="text-sm text-gray-500 mt-6 bg-slate-100 p-4">
                <!-- Parts and Garage: Ts and Cs Blurb -->
                <span class="text-sm text-gray-700 block mb-2">Important Information About Parts and Garage Cover</span>
                <div v-if="form.vehicles.length > 1" class="mb-2">
                    <span class="text-sm text-gray-700 block mb-1 pt-1">
                        Vehicles included in Parts and Garage cover:
                    </span>
                    <div v-if="showPartsLabourError" class="mt-2 mb-2 px-2 py-3 bg-red-500 text-white font-semibold">
                        For Parts and Garage Cover to be active you must select at least 1 vehicle to be included for Parts and Garage
                    </div>
                    <div v-for="(vehicle, index) in form.vehicles"
                    :key="index" class="bg-gray-100 flex items-center px-2 sm:px-2 py-2 rounded-md">
                        <div class="pr-2">
                            <span class="text-red-500" v-if="vehicle.parts_exclude == 'exclude'">&#10006;</span>
                            <span class="text-green-500" v-else>&#10004;</span>
                        </div>
                        <div
                            v-if="vehicle.vrm.value"
                            class="mr-4 px-2 sm:px-4 py-1 rounded-md flex-shrink-0 bg-yellow-300 text-black uppercase text-lg text-center font-bold">
                            <span>{{ vehicle.vrm.value }}</span>
                        </div>
                        <div class="">
                            <div class="text-sm leading-5" :class="{
                                'line-through': vehicle.parts_exclude == 'exclude',
                            }">
                                {{ vehicle.make.value }} {{ vehicle.model.value }}
                            </div>
                        </div>
                        <div class="text-sm pl-2 ml-auto">
                            <div
                                class="relative inline-flex items-center px-3 sm:px-4 py-1 md:py-2 border text-xs md:text-sm font-medium focus:z-10 focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-500 rounded-md border-gray-300 bg-white text-gray-400 hover:bg-gray-50 cursor-pointer"
                                @click="addRemovePartsLabour(vehicle)">
                                <span v-if="vehicle.parts_exclude == 'exclude'">Add</span>
                                <span v-else>Remove</span>
                            </div>
                        </div>
                    </div>
                </div>
                <span class="text-sm text-gray-700 block mb-2">We do not cover:</span>
                <ul class="list-disc mb-2 px-6">
                    <li>Any faults or claims that occur within the first 14 days of purchase</li>
                    <li>Faults that existed before you purchased a {{ companyName }} membership</li>
                    <li>Parts covered by an existing warranty policy</li>
                    <li>Parts designed to wear over time, e.g. clutch friction plates, tyres, wipers – see our <a
                        href="/parts-and-garage-cover-membership-terms" target="_blank" class="underline">Membership Terms</a> for a full
                        list of exclusions
                    </li>
                    <li>Vehicles used for business purposes – e.g. taxis, couriers</li>
                </ul>
                <span class="text-sm text-gray-700 block">Before you can make a valid claim, you first need to contact us to report your breakdown</span>
            </div>

            <div v-if="form.parts_labour.value == 1 && partsAndLabourPrice" class="text-sm block mt-3 leading-normal text-gray-500">
                <span class="text-base">Parts and Garage Cover: <span class="text-lg font-bold block md:inline">{{ partsAndLabourPrice | toCurrency }} of your quote</span></span>
            </div>

            <div v-if="stylingNewVersion">
                 <div class="mt-6 md:mt-6 pb-4 bg-gray-50 p-4 rounded-md mb-0 text-left">
                                <div class="text-sm font-base text-gray-700 font-poppins">
                                    <strong>Why Choose Us?</strong>
                 
                                    <div class=" mt-1 clear-both block md:hidden">

                                           <span class="flex md:hidden-- items-center float-left mr-4 pt-2">
                                            <svg width="20" height="22" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 65.729 70.107" class="block lg:block flex-shrink-0 mr-2"><defs></defs> <g transform="translate(-16 0.005)"><path d="M77.689,11.453,51.4.5a6.593,6.593,0,0,0-5.053,0L20.053,11.453A6.573,6.573,0,0,0,16,17.523C16,44.7,31.679,63.491,46.331,69.6a6.593,6.593,0,0,0,5.053,0c11.735-4.89,30.345-21.775,30.345-52.075a6.573,6.573,0,0,0-4.04-6.07ZM71.226,27.092l-25.2,25.2a2.2,2.2,0,0,1-3.095,0L28.694,38.047a2.2,2.2,0,0,1,0-3.1l3.095-3.095a2.2,2.2,0,0,1,3.095,0l9.6,9.6L65.036,20.9a2.2,2.2,0,0,1,3.095,0L71.226,24a2.176,2.176,0,0,1,0,3.1Z" transform="translate(0 0)" class="shield-check-a"></path> <path d="M147.22,154.853l-25.2,25.2a2.2,2.2,0,0,1-3.095,0l-14.241-14.241a2.2,2.2,0,0,1,0-3.1l3.095-3.095a2.2,2.2,0,0,1,3.095,0l9.6,9.6,20.554-20.554a2.2,2.2,0,0,1,3.095,0l3.095,3.095a2.176,2.176,0,0,1,0,3.1Z" transform="translate(-75.994 -127.76)" class="shield-check-b"></path></g></svg> 
                                        <span>UK's Best Rated Service</span>
                                        </span>
                                        
                                            <span class="flex md:hidden-- items-center float-left mr-4 pt-2" v-show="!isBusinessFlow()">
                                            <svg width="20" height="22" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 65.729 70.107" class="block lg:block flex-shrink-0 mr-2"><defs></defs> <g transform="translate(-16 0.005)"><path d="M77.689,11.453,51.4.5a6.593,6.593,0,0,0-5.053,0L20.053,11.453A6.573,6.573,0,0,0,16,17.523C16,44.7,31.679,63.491,46.331,69.6a6.593,6.593,0,0,0,5.053,0c11.735-4.89,30.345-21.775,30.345-52.075a6.573,6.573,0,0,0-4.04-6.07ZM71.226,27.092l-25.2,25.2a2.2,2.2,0,0,1-3.095,0L28.694,38.047a2.2,2.2,0,0,1,0-3.1l3.095-3.095a2.2,2.2,0,0,1,3.095,0l9.6,9.6L65.036,20.9a2.2,2.2,0,0,1,3.095,0L71.226,24a2.176,2.176,0,0,1,0,3.1Z" transform="translate(0 0)" class="shield-check-a"></path> <path d="M147.22,154.853l-25.2,25.2a2.2,2.2,0,0,1-3.095,0l-14.241-14.241a2.2,2.2,0,0,1,0-3.1l3.095-3.095a2.2,2.2,0,0,1,3.095,0l9.6,9.6,20.554-20.554a2.2,2.2,0,0,1,3.095,0l3.095,3.095a2.176,2.176,0,0,1,0,3.1Z" transform="translate(-75.994 -127.76)" class="shield-check-b"></path></g></svg> 
                                        <span>Best Price Guarantee<sup class="text-base" style="font-size: 9px !important;">2</sup></span>
                                        </span>
                                        
                                        <span class="flex items-center float-left mr-4 pt-2 md:pt-1.5">
                                            <svg width="20" height="22" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 65.729 70.107" class="block lg:block flex-shrink-0 mr-2"><defs></defs> <g transform="translate(-16 0.005)"><path d="M77.689,11.453,51.4.5a6.593,6.593,0,0,0-5.053,0L20.053,11.453A6.573,6.573,0,0,0,16,17.523C16,44.7,31.679,63.491,46.331,69.6a6.593,6.593,0,0,0,5.053,0c11.735-4.89,30.345-21.775,30.345-52.075a6.573,6.573,0,0,0-4.04-6.07ZM71.226,27.092l-25.2,25.2a2.2,2.2,0,0,1-3.095,0L28.694,38.047a2.2,2.2,0,0,1,0-3.1l3.095-3.095a2.2,2.2,0,0,1,3.095,0l9.6,9.6L65.036,20.9a2.2,2.2,0,0,1,3.095,0L71.226,24a2.176,2.176,0,0,1,0,3.1Z" transform="translate(0 0)" class="shield-check-a"></path> <path d="M147.22,154.853l-25.2,25.2a2.2,2.2,0,0,1-3.095,0l-14.241-14.241a2.2,2.2,0,0,1,0-3.1l3.095-3.095a2.2,2.2,0,0,1,3.095,0l9.6,9.6,20.554-20.554a2.2,2.2,0,0,1,3.095,0l3.095,3.095a2.176,2.176,0,0,1,0,3.1Z" transform="translate(-75.994 -127.76)" class="shield-check-b"></path></g></svg> 
                                            <span>80% of Vehicles Fixed Roadside</span>
                                        </span>

                                        <span class="flex items-center float-left mr-4 pt-2 md:pt-1.5">
                                            <svg width="20" height="22" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 65.729 70.107" class="block lg:block flex-shrink-0 mr-2"><defs></defs> <g transform="translate(-16 0.005)"><path d="M77.689,11.453,51.4.5a6.593,6.593,0,0,0-5.053,0L20.053,11.453A6.573,6.573,0,0,0,16,17.523C16,44.7,31.679,63.491,46.331,69.6a6.593,6.593,0,0,0,5.053,0c11.735-4.89,30.345-21.775,30.345-52.075a6.573,6.573,0,0,0-4.04-6.07ZM71.226,27.092l-25.2,25.2a2.2,2.2,0,0,1-3.095,0L28.694,38.047a2.2,2.2,0,0,1,0-3.1l3.095-3.095a2.2,2.2,0,0,1,3.095,0l9.6,9.6L65.036,20.9a2.2,2.2,0,0,1,3.095,0L71.226,24a2.176,2.176,0,0,1,0,3.1Z" transform="translate(0 0)" class="shield-check-a"></path> <path d="M147.22,154.853l-25.2,25.2a2.2,2.2,0,0,1-3.095,0l-14.241-14.241a2.2,2.2,0,0,1,0-3.1l3.095-3.095a2.2,2.2,0,0,1,3.095,0l9.6,9.6,20.554-20.554a2.2,2.2,0,0,1,3.095,0l3.095,3.095a2.176,2.176,0,0,1,0,3.1Z" transform="translate(-75.994 -127.76)" class="shield-check-b"></path></g></svg> 
                                            <span>Average Arrival Time of 43 Mins</span>
                                        </span>
                                        <div class="clear-both"></div>
                                    </div>

                                    <div class=" mt-1 clear-both hidden md:block">
                                        <span class="flex md:hidden-- items-center float-left mr-4 pt-2" v-show="!isBusinessFlow()">
                                            <svg width="20" height="22" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 65.729 70.107" class="block lg:block flex-shrink-0 mr-2"><defs></defs> <g transform="translate(-16 0.005)"><path d="M77.689,11.453,51.4.5a6.593,6.593,0,0,0-5.053,0L20.053,11.453A6.573,6.573,0,0,0,16,17.523C16,44.7,31.679,63.491,46.331,69.6a6.593,6.593,0,0,0,5.053,0c11.735-4.89,30.345-21.775,30.345-52.075a6.573,6.573,0,0,0-4.04-6.07ZM71.226,27.092l-25.2,25.2a2.2,2.2,0,0,1-3.095,0L28.694,38.047a2.2,2.2,0,0,1,0-3.1l3.095-3.095a2.2,2.2,0,0,1,3.095,0l9.6,9.6L65.036,20.9a2.2,2.2,0,0,1,3.095,0L71.226,24a2.176,2.176,0,0,1,0,3.1Z" transform="translate(0 0)" class="shield-check-a"></path> <path d="M147.22,154.853l-25.2,25.2a2.2,2.2,0,0,1-3.095,0l-14.241-14.241a2.2,2.2,0,0,1,0-3.1l3.095-3.095a2.2,2.2,0,0,1,3.095,0l9.6,9.6,20.554-20.554a2.2,2.2,0,0,1,3.095,0l3.095,3.095a2.176,2.176,0,0,1,0,3.1Z" transform="translate(-75.994 -127.76)" class="shield-check-b"></path></g></svg> 
                                        <span>We guarantee that our prices will always be lower<sup class="text-base" style="font-size: 9px !important;">2</sup></span>
                                        </span>
                                        
                                        <span class="flex items-center float-left mr-4 pt-2 md:pt-1.5">
                                            <svg width="20" height="22" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 65.729 70.107" class="block lg:block flex-shrink-0 mr-2"><defs></defs> <g transform="translate(-16 0.005)"><path d="M77.689,11.453,51.4.5a6.593,6.593,0,0,0-5.053,0L20.053,11.453A6.573,6.573,0,0,0,16,17.523C16,44.7,31.679,63.491,46.331,69.6a6.593,6.593,0,0,0,5.053,0c11.735-4.89,30.345-21.775,30.345-52.075a6.573,6.573,0,0,0-4.04-6.07ZM71.226,27.092l-25.2,25.2a2.2,2.2,0,0,1-3.095,0L28.694,38.047a2.2,2.2,0,0,1,0-3.1l3.095-3.095a2.2,2.2,0,0,1,3.095,0l9.6,9.6L65.036,20.9a2.2,2.2,0,0,1,3.095,0L71.226,24a2.176,2.176,0,0,1,0,3.1Z" transform="translate(0 0)" class="shield-check-a"></path> <path d="M147.22,154.853l-25.2,25.2a2.2,2.2,0,0,1-3.095,0l-14.241-14.241a2.2,2.2,0,0,1,0-3.1l3.095-3.095a2.2,2.2,0,0,1,3.095,0l9.6,9.6,20.554-20.554a2.2,2.2,0,0,1,3.095,0l3.095,3.095a2.176,2.176,0,0,1,0,3.1Z" transform="translate(-75.994 -127.76)" class="shield-check-b"></path></g></svg> 
                                        <span>UK's Best Rated Service giving you total peace of mind</span>
                                        </span>
                                        <span class="flex items-center float-left mr-4 pt-2 md:pt-1.5">
                                            <svg width="20" height="22" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 65.729 70.107" class="block lg:block flex-shrink-0 mr-2"><defs></defs> <g transform="translate(-16 0.005)"><path d="M77.689,11.453,51.4.5a6.593,6.593,0,0,0-5.053,0L20.053,11.453A6.573,6.573,0,0,0,16,17.523C16,44.7,31.679,63.491,46.331,69.6a6.593,6.593,0,0,0,5.053,0c11.735-4.89,30.345-21.775,30.345-52.075a6.573,6.573,0,0,0-4.04-6.07ZM71.226,27.092l-25.2,25.2a2.2,2.2,0,0,1-3.095,0L28.694,38.047a2.2,2.2,0,0,1,0-3.1l3.095-3.095a2.2,2.2,0,0,1,3.095,0l9.6,9.6L65.036,20.9a2.2,2.2,0,0,1,3.095,0L71.226,24a2.176,2.176,0,0,1,0,3.1Z" transform="translate(0 0)" class="shield-check-a"></path> <path d="M147.22,154.853l-25.2,25.2a2.2,2.2,0,0,1-3.095,0l-14.241-14.241a2.2,2.2,0,0,1,0-3.1l3.095-3.095a2.2,2.2,0,0,1,3.095,0l9.6,9.6,20.554-20.554a2.2,2.2,0,0,1,3.095,0l3.095,3.095a2.176,2.176,0,0,1,0,3.1Z" transform="translate(-75.994 -127.76)" class="shield-check-b"></path></g></svg> 
                                            <span>On average, our 24/7 call centre answers in under 40 seconds</span>
                                        </span>

                                        <span class="flex items-center float-left mr-4 pt-2 md:pt-1.5">
                                            <svg width="20" height="22" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 65.729 70.107" class="block lg:block flex-shrink-0 mr-2"><defs></defs> <g transform="translate(-16 0.005)"><path d="M77.689,11.453,51.4.5a6.593,6.593,0,0,0-5.053,0L20.053,11.453A6.573,6.573,0,0,0,16,17.523C16,44.7,31.679,63.491,46.331,69.6a6.593,6.593,0,0,0,5.053,0c11.735-4.89,30.345-21.775,30.345-52.075a6.573,6.573,0,0,0-4.04-6.07ZM71.226,27.092l-25.2,25.2a2.2,2.2,0,0,1-3.095,0L28.694,38.047a2.2,2.2,0,0,1,0-3.1l3.095-3.095a2.2,2.2,0,0,1,3.095,0l9.6,9.6L65.036,20.9a2.2,2.2,0,0,1,3.095,0L71.226,24a2.176,2.176,0,0,1,0,3.1Z" transform="translate(0 0)" class="shield-check-a"></path> <path d="M147.22,154.853l-25.2,25.2a2.2,2.2,0,0,1-3.095,0l-14.241-14.241a2.2,2.2,0,0,1,0-3.1l3.095-3.095a2.2,2.2,0,0,1,3.095,0l9.6,9.6,20.554-20.554a2.2,2.2,0,0,1,3.095,0l3.095,3.095a2.176,2.176,0,0,1,0,3.1Z" transform="translate(-75.994 -127.76)" class="shield-check-b"></path></g></svg> 
                                            <span>We fix 80% of vehicles roadside and arrive in 43 minutes on average </span>
                                        </span>
                                        <div class="clear-both"></div>
                                    </div>
                             
                                </div>
                            </div>
            </div>

        </div>
        <button
            data-testid="pricebox__cta"
            type="submit"
            name="pricebox__cta"
            class="w-full flex items-center justify-center px-5 py-3 border text-base lg:text-lg font-bold font-poppins rounded-md mt-8 main-flow-bottom--cta"
            @click.prevent="handleReviewSubmit"
            ref="reviewContinueButton"
            :class="{
                'bg-gray-200 text-gray-400 text-opacity-100 cursor-pointer border-gray-300': ctaDisabled,
                'bg-green-500 hover:bg-green-700 text-white border-transparent': !ctaDisabled,
                'block md:block' : stylingNewVersion && !ctaDisabled
            }"
        >
            {{ reviewCta }}
        </button>

        <div v-if="stylingNewVersion" id="tp-widget__mobile-v2" class="lg:hidden mt-8 mb-12 w-full relative">
               
                <div ref="trustboxMobilev2" class="trustpilot-widget left-1" data-locale="en-GB" data-template-id="5419b732fbfb950b10de65e5"
                    data-businessunit-id="5d88b4f90f1ce20001cb981f" data-style-height="24px" data-style-width="100%" data-theme="light">
                    <a href="https://uk.trustpilot.com/review/motoringassistance.com" target="_blank" rel="noopener">Trustpilot</a>
                </div>
        </div>
    </div>
</template>

<script>
import Toggle from "../Toggle";
import { mapGetters } from "vuex";
import ButtonGroup from "../ButtonGroupNew";
import ServiceInformation from "../ServiceInformation.vue";
import { EventBus } from './../../common/eventBus';
import { COVER_TYPE } from "../../constants";

export default {
    name: "Review",
    components: {
        Toggle,
        ButtonGroup,
        ServiceInformation,
    },
    props: {
        ctaDisabled: {
            type: Boolean,
            default: true,
        },
        form: {
            type: Object,
            default: () => {},
        },
        steps: {
            type: Array,
            default: () => [],
        },
        companyName: {
            type: String,
            default: 'Motoring Assistance'
        },
        partsAndLabourPrice: {
            type: Number,
            default: 0,
        },
        isWhiteLabel: {
            type: Boolean,
            default: false,
        },
        servicePricing: {
            type: Array,
            default: () => [],
        },
        hexColor: {
            type: [String, null],
            default: null
        },
        stylingNewVersion: {
            type: Boolean,
            default: false,
        },
        splitTest: {
            type: Boolean,
            default: false,
        },
        coupon: {
            type: Object,
            default: () => {
            },
        },
        flowIconVersion: {
            type: Boolean, 
            default: false 
        },
        flowTpBottom: {
            type: Boolean, 
            default: false 
        },
        showMultiVehicleWording: {
            type: Boolean, 
            default: false 
        },
        reviewCta: {
            type: String,
            default: 'Continue',
        },
    },
    data() {
        return {
            allowHomeTopSection: true,
            allowNationwideTopSection: true,
            showPartsLabourError: false,
            showDescription: false,
            allowFreeProdTopSection: true,
            errorsArray: [],
            localReviewDisableContinue: this.ctaDisabled,
        };
    },
    computed: {
        ...mapGetters({
            hidden_excess: 'hidden_excess',
            quote: 'quote',
        }),


        includedAsStandard() {

            let standardOptions = ['roadside', 'local', 'accident', 'unlimited']
            
            if (this.form.home.value === 1 && this.allowHomeTopSection) {
                standardOptions.push('home') // Add home start if selected
            }

            if (this.form.nationwide.value === 1 && this.allowNationwideTopSection) {
                standardOptions.push('nationwide') // Add nationwide if selected
                standardOptions.splice(1, 1) // Remove Local
            }

            if (typeof this.quote.coupon !== null && this?.quote?.coupon?.discountType === 'FREE_PRODUCT') {
                if (this.quote.coupon.value === 'FREEONWARD') {
                    standardOptions.push('onward');
                } else if (this.quote.coupon.value === 'FREEMISFUEL') {
                    standardOptions.push('misfuel');
                }
            }

            return standardOptions
        },

        addons() {

            let addonsServices = ['home', 'nationwide', 'battery', 'onward', 'misfuel', 'personal']; // Tyre Off
            if(this.form?.cover_type?.value === COVER_TYPE.personalCover) {
                addonsServices = ['home', 'nationwide', 'misfuel', 'onward'];
            }

            let freeService = null;

            if (this.form.home.value === 0) {
                this.allowHomeTopSection = false
                this.form.home.hideWhenSelected = false
            }

            if (this.form.nationwide.value === 0) {
                this.allowNationwideTopSection = false
                this.form.nationwide.hideWhenSelected = false
            }

            if (this.form.nationwide.value === 0) {
                this.allowNationwideTopSection = false
                this.form.nationwide.hideWhenSelected = false
            }

            if (typeof this.quote.coupon !== null && this?.quote?.coupon?.discountType === 'FREE_PRODUCT') {
                switch (this.quote.coupon.value) {
                    case 'FREEMISFUEL':
                        freeService = 'misfuel';
                        break;

                    case 'FREEONWARD':
                        freeService = 'onward';
                        break;
                }
            }

            if (this.isBusinessFlow()) {
                addonsServices = ['home', 'nationwide', 'onward', 'misfuel'];
            }

            if (freeService !== null) {
                const index = addonsServices.indexOf(freeService);
                if (index !== -1) {
                    addonsServices.splice(index, 1);
                }
            }
            return addonsServices

        },
        extras() {

            if (this.isBusinessFlow()) {
                return []
            }

            // Re. commented out services - work was done in Q1.23 but JZ requested not to go live.
            // The services may be on sale through the CMS so take care when adjusting.
            return ['parts_labour',/*'european', 'accident_plus', 'caravan_trailer', 'key' */]

        },

    },
    methods: {
        checkAddons() {
            const allAddonsValid = this.addons.every(addon => this.form[addon]?.value === 0 || this.form[addon]?.value === 1);
            
            this.$emit('update-review-disable-continue', allAddonsValid);
        },
        handleReviewSubmit() {
        
            // Split Test Allow to Go through without choosing all options.
            if(!this.ctaDisabled){
                this.$nextTick(() => {
                    //document.getElementById('join__quote').submit()
                    this.$emit('submit-cta-bottom', true);
                })
                return
            }

            this.errorsArray = [];
            this.addons.forEach((addon) => {
                if (this.form[addon]?.value !== 1 && this.form[addon]?.value !== 0) {
                    this.errorsArray.push(addon);
                }
            });

            // check for button group errors and if we have options not selected
            if (this.errorsArray.length > 0) {
                const firstError = this.errorsArray[0];
                const element = this.$refs[firstError]?.[0];

                if (element) {
                    element.$el.scrollIntoView({
                        behavior: "smooth",
                        block: "start",
                    });
                }
                return;
            } else {
                this.$nextTick(() => {
                    //document.getElementById('join__quote').submit()
                    this.$emit('submit-cta-bottom', true);
                })
            }
        },
        toggleShowDescript() {
            this.showDescription = !this.showDescription;
        },
        updateQuotePrice() {
            this.$emit('update-quote-price', true)
        },
        reviewRemoveService(key) {
            if (key == "Home Start") {
                this.form.home.value = 0
                this.allowHomeTopSection = false
                this.form.home.hideWhenSelected = false
                this.$emit('update-quote-price', true)
            }

            if (key == "Nationwide Recovery") {
                this.form.nationwide.value = 0
                this.allowNationwideTopSection = false
                this.form.nationwide.hideWhenSelected = false
                this.$emit('update-quote-price', true)
            }
        },
        addRemovePartsLabour(vehicle) {

            this.showPartsLabourError = false

            if (!vehicle.parts_exclude) {

                if (this.form.vehicles.filter(vitem => vitem.parts_exclude == "").length < 2) {
                    this.showPartsLabourError = true
                    return
                }

                vehicle.parts_exclude = "exclude"
            } else {
                vehicle.parts_exclude = ""
            }

            this.$emit('update-quote-price', true)

        },
        getOptions(addon) {

            // if (this.quote.coupon.discountType === "FREE_PRODUCT") {
            //
            //     if (this.quote.coupon.value === 'FREEMISFUEL') {
            //         return [...this.form[addon].optionsToggle, 'misfuel'];
            //     } else if (this.quote.coupon.value === 'FREEONWARD') {
            //             return [...this.form[addon].optionsToggle, 'onward'];
            //
            //     }
            // }
            // return this.form[addon].optionsToggle;
        },
        updateFreeAddon() {

            this.form.onward.free = this.includedAsStandard.includes('onward');
            this.form.misfuel.free = this.includedAsStandard.includes('misfuel');

        },
        setAllAddonsToZero() {
            this.addons.forEach((addon) => {
                if (this.form[addon]) {
                    this.form[addon].value = 0;
                }
            });
            // this.$emit('update-quote-price', true);
        },
        showCallUsHideTimer() {
            // Hide Timers + Show Call Us.
            // Only do in Working Hours and call us mobile button element is available.
            if(document.getElementById('callus-mobile')){
                if(document.getElementById('timer-nav--mobile')){
                    document.getElementById('timer-nav--mobile').classList.add('hidden')
                }

                if(document.getElementById('discount-banner')){
                    document.getElementById('discount-banner').classList.add('hidden')
                }

                // Show Call Us
                if(document.getElementById('nav-logo')){
                    document.getElementById('nav-logo').classList.remove('hidden')
                }

                if(document.getElementById('callus-mobile')){
                    document.getElementById('callus-mobile').classList.remove('hidden')
                }

                if(document.getElementById('callus-desktop')){
                    document.getElementById('callus-desktop').classList.remove('hidden')
                }
            }
        }
    },
    mounted() {
        EventBus.$on('submitReview', this.handleReviewSubmit);
        this.$emit('init-quote', true)
        window.scroll(0, 0)
        this.updateFreeAddon();
        this.showCallUsHideTimer();
        this.checkAddons();
        if(this.stylingNewVersion){
            const trustbox = this.$refs.trustboxMobilev2;
            if (window.Trustpilot) {
                window.Trustpilot.loadFromElement(trustbox);
            }

            //document.querySelector('#footer-legal-information').classList.add('hidden');

        }

        console.log(this.form)

        this.$nextTick(function () {

            if (window.innerHeight < 800) {
                document.getElementsByClassName('tp-wdiget-review')[0].setAttribute('data-style-height', '300px')
            }
            this.$emit('load-trustpilot', true)
            this.$emit('send-hotjar-identifier', true)

            if (window.hj) {
              window.hj('stateChange', '/breakdown-cover/your-quote/review');  // Track page view
            }

        })
        this.$root.$on('eventing', data => {
            console.log(data);
        });
    },
    beforeDestroy() {

        EventBus.$off('submitReview', this.handleReviewSubmit);
    },
    watch: {
        form: {
            handler(newVal) {
                this.checkAddons();
            },
            deep: true, // Enables deep watching for nested properties
        },
    },
};
</script>

<style scoped>
.your-quote-heading-multi-vehicle {
  display:block;
}

@media (min-width: 389px) {
  .your-quote-heading-multi-vehicle {
      display:inline-block;
    }
}
</style>
